<div mat-dialog-content cdkFocusInitial class="max-width-modal-ie">
  <mat-card>
    <mat-card-header>
      <mat-card-title
        >LIQUIDACIÓN {{ data?.FechaPago | date: 'MM-yyyy' }}</mat-card-title
      >
    </mat-card-header>
    <mat-card-content>
      <div class="button-content">
        <button
          (click)="onClickPrint()"
          mat-stroked-button
          class="button-cerrar"
        >
          Descargar
        </button>
      </div>

      <div id="nodeToRenderAsPDF">
        <div class="card-content">
          <div class="blue-title">
            DETALLE DE PAGO
          </div>

          <div class="detalle-grid">
            <div class="data-pair aa ms-margen">
              <span class="label">Número de póliza</span>
              <span class="value">{{ data?.NumPoliza }}</span>
            </div>

            <div class="data-pair ab border-bottom ms-margen">
              <span class="label">Pensión UF</span>
              <span class="value">{{ data?.Renta | number }}</span>
            </div>

            <div class="data-pair ac border-bottom ms-margen">
              <span class="label">Valor UF</span>
              <span class="value">{{ data?.ValorUF | number }}</span>
            </div>

            <div class="data-pair bb border-bottom ms-margen">
              <span class="label">Período de Pago</span>
              <span class="value">{{ data?.MesProceso }}</span>
            </div>

            <div class="data-pair bc border-bottom ms-margen">
              <span class="label">Fecha de Pago</span>
              <span class="value">{{ data?.FechaPagoUI }}</span>
            </div>

            <div class="data-pair bd border-bottom ms-margen">
              <span class="label">Fecha Próximo Pago</span>
              <span class="value">{{ data?.ProximoPagoUI }}</span>
            </div>

            <div class="data-pair cb border-bottom ms-margen">
              <span class="label">Nombre Apoderado</span>
              <span class="value">{{
                data?.NombreTutor ? data?.NombreTutor : '-'
              }}</span>
            </div>

            <div class="data-pair cd border-bottom ms-margen">
              <span class="label">Rut Apoderado</span>
              <span class="value">{{
                data?.RutTutor ? data?.RutTutor : '-'
              }}</span>
            </div>

            <div class="data-pair db border-bottom ms-margen">
              <span class="label">Dirección de Pago</span>
              <span class="value">{{ data?.DireccionPago }} </span>
            </div>

            <div class="data-pair dc border-bottom ms-margen">
              <span class="label">Via de Pago</span>
              <span class="value">{{ data?.ViaPago }}</span>
            </div>

            <div class="data-pair eb ms-margen">
              <span class="label">Forma de Pago</span>
              <span class="value"
                >{{ data?.TipoCuenta }} {{ data?.Banco | titlecase }}</span
              >
            </div>

            <div class="data-pair ec ms-margen">
              <span class="label">Cuenta</span>
              <span class="value">{{ data?.NumeroCuenta }}</span>
            </div>
          </div>

          <div class="blue-title" style="margin-top: 25px">
            {{ 'Liquidación De Pago' | uppercase }}
          </div>

          <div class="persondata-grid">
            <div class="data-pair fa ms-margen">
              <span class="label">Rut Beneficiario</span>
              <span class="value">{{
                data?.RutBeneficiario ? data?.RutBeneficiario : '-'
              }}</span>
            </div>

            <div class="data-pair fb ms-margen">
              <span class="label">Nombre Beneficiario</span>
              <span class="value">{{
                data?.NombreBeneficiario ? data?.NombreBeneficiario : '-'
              }}</span>
            </div>

            <div class="data-pair fd ms-margen">
              <span class="label">Parentesco Beneficiario</span>
              <span class="value">{{ data?.Parentesco }}</span>
            </div>

            <div class="data-pair ga ms-margen">
              <span class="label">Nº Liquidación</span>
              <span class="value">{{ data?.NumeroLiquidacion }}</span>
            </div>

            <div class="data-pair gb ms-margen">
              <span class="label">Tipo Pensión</span>
              <span class="value">{{ data?.TipoPension }}</span>
            </div>

            <div class="data-pair gd ms-margen">
              <span class="label">Institución de Salud</span>
              <span class="value">{{ data?.Isapre ? data?.Isapre : '-' }}</span>
            </div>
          </div>

          <div class="tables-grid">
            <div class="ha">
              <div class="ha-row">
                <div class="table-title table-grid-ha-row-a">
                  <label>DETALLE HABERES</label>
                </div>
                <div class="table-title align-end table-grid-ha-row-b">
                  <label>MONTO ($)</label>
                </div>
              </div>

              <div class="ha-row" *ngFor="let item of data.Haberes">
                <div class="table-value table-grid-ha-row-a">
                  <span>{{ item.Descripcion }}</span>
                </div>
                <div class="table-value align-end table-grid-ha-row-b">
                  <span>
                    {{ item.Monto ? '$' + (item.Monto | number) : '' }}</span
                  >
                </div>
              </div>

              <div class="ha-row">
                <div class="table-total table-grid-ha-row-a">
                  <span>TOTAL HABERES</span>
                </div>
                <div
                  class="table-total table-total-value align-end table-grid-ha-row-b"
                >
                  <span
                    >$ {{ data?.Haberes ? (sumHaberes() | number) : '0' }}</span
                  >
                </div>
              </div>
              <div class="ha-row">
                <div class="table-total table-grid-ha-row-a">
                  <span>TOTAL BASE IMPONIBLE</span>
                </div>
                <div
                  class="table-total table-total-value align-end table-grid-ha-row-b"
                >
                  <span>{{
                    data.Imponible ? '$' + (data.Imponible | number) : ''
                  }}</span>
                </div>
              </div>
              <div class="ha-row">
                <div class="table-total table-grid-ha-row-a">
                  <span>TOTAL TRIBUTABLE</span>
                </div>
                <div
                  class="table-total table-total-value align-end table-grid-ha-row-b"
                >
                  <span>{{
                    data.Tributable ? '$' + (data.Tributable | number) : ''
                  }}</span>
                </div>
              </div>
            </div>

            <div class="hb">
              <div class="ha-row">
                <div class="table-title table-grid-ha-row-a">
                  <label>DETALLE DESCUENTOS</label>
                </div>
                <div class="table-title align-end table-grid-ha-row-b">
                  <label>MONTO ($)</label>
                </div>
              </div>
              <div class="ha-row" *ngFor="let item of data.Descuentos">
                <div class="table-value table-grid-ha-row-a">
                  <span>{{ item.Descripcion }}</span>
                </div>
                <div class="table-value align-end table-grid-ha-row-b">
                  <span>{{
                    item.Monto ? '$' + (item.Monto | number) : ''
                  }}</span>
                </div>
              </div>
              <div class="ha-row">
                <div class="table-total table-grid-ha-row-a">
                  <span>TOTAL DESCUENTO</span>
                </div>
                <div
                  class="table-total table-total-value align-end table-grid-ha-row-b"
                >
                  <span
                    >$
                    {{
                      data?.Descuentos ? (sumDescuentos() | number) : '0'
                    }}</span
                  >
                </div>
              </div>
              <div class="ha-row">
                <div class="table-total table-grid-ha-row-a">
                  <span>TOTAL LÍQUIDO A PAGAR</span>
                </div>
                <div
                  class="table-total table-total-value align-end table-grid-ha-row-b"
                >
                  <span>$ {{ data.Liquido | number }}</span>
                </div>
              </div>
            </div>

            <div class="ib"></div>
          </div>
        </div>
      </div>

      <div class="button-content" style="margin-bottom: 0.625rem;">
        <button [mat-dialog-close]="" mat-stroked-button class="button-cerrar">
          Cerrar
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</div>
